import { render, staticRenderFns } from "./ProductSetDetails.vue?vue&type=template&id=9b34b2c0&scoped=true"
import script from "./ProductSetDetails.vue?vue&type=script&lang=js"
export * from "./ProductSetDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductSetDetails.vue?vue&type=style&index=0&id=9b34b2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b34b2c0",
  null
  
)

export default component.exports